import {
    DeleteOutlined,
    DownOutlined,
    EditOutlined,
    ExclamationCircleOutlined,
    MailOutlined,
} from "@ant-design/icons";
import {
    Button,
    Checkbox,
    Col,
    Divider,
    Dropdown,
    MenuProps,
    Modal,
    Popover,
    Radio,
    RadioChangeEvent,
    Row,
    Select,
    Space,
    Tag,
} from "antd";
import { Option } from "antd/es/mentions";
import { useEffect, useState } from "react";
import { MdOutlineSubject } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";



import "./activeLists.scss";
import { fetchUsersList, multiFunctionDeleteUsers, resendEmail } from "../../../features/users/usersSlice";
import { handleApiResponse } from "../../../utils/helper";
import { appDispatch, RootState } from "../../../app/store";
import { fetchSitesList, resetFetchSitesList } from "../../../features/sites/sitesSlice";
import { fetchSpecialityList, resetFetchSpecialityList } from "../../../features/speciality/specialitySlice";
import { fetchRolesList, resetFetchRolesList } from "../../../features/userRoles/userRolesSlice";
import { fetchONSpecialities } from "../../../features/superAdmin/requestLIsts/requestListsSlice";
import { filterMembers } from "../../../features/members/membersSlice";

interface UserTableActionProps {
    selectedRows: any;
    fetchUsersListData?: any[];
    activeTab: any;
    selectedAlphabet?: any;
    onSpecialityChange: any;
    selectedSpeciality: any;
    onActiveChange: any;
    onClearAll: any;
    onRoleChange: any;
    roleCheckedList: any;
    onSiteChange?: any;
    setUseSelectedRows?: any;
    resetTableSelection?: any;
    onFilterResults?: (results: any[]) => void; // <-- NEW

}

const { confirm } = Modal;

const ActiveListAction: React.FC<UserTableActionProps> = ({
    selectedRows,
    selectedAlphabet,
    activeTab,
    fetchUsersListData,
    onSpecialityChange,
    onSiteChange,
    onActiveChange,
    onClearAll,
    onRoleChange,
    setUseSelectedRows,
    resetTableSelection, onFilterResults
}) => {
    const [site, setSite] = useState("All");
    const [speciality, setSpeciality] = useState("All");
    const [active, setActive]: any = useState([]);
    const [roleCheckedList, setRoleCheckedList] = useState<string>("");
    const [isPopoverVisible, setPopoverVisible] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [alphabet, setAlphabet] = useState("All");
    const [selectedRole, setSelectedRole] = useState<any[]>([]);
    const [selectedSpecialty, setSelectedSpecialty] = useState<any[]>([]);
    const [membershipPlans, setMembershipPlans] = useState<string[]>([]);
    const [selectedStatus, setSelectedStatus] = useState<any[]>([]);
    const [selectedMMPlan, setSelectedMMPlan] = useState<any[]>([]);
    const [backupFilters, setBackupFilters] = useState({
        membershipPlans: [] as string[],
        selectedStatus: [] as any[],
        selectedMMPlan: [] as any[],
        selectedRole: [] as any[],
        selectedSpecialty: [] as any[],
    });
    console.log("selectedStats", selectedStatus)
    const planOptions = [
        { label: "Free", value: "1" },
        { label: "Basic", value: "2" },
        { label: "Plus", value: "3" },
    ];

    const [pageNumber, setPageNumber] = useState(1);
    const { fetchRolesListData } = useSelector(
        (state: RootState) => state.roles.fetchRolesList
    );
    const { fetchSitesListData } = useSelector(
        (state: RootState) => state.sites.fetchSitesList
    );
    const {
        ONSpecialitiesListData,
        isLoading: isONSpecialitiesLoading
    } = useSelector((state: RootState) => state.requestLsts.fetchONSpecialities);

    const {
        ONRolesListData,
        isLoading: isONRolesLoading
    } = useSelector((state: RootState) => state.requestLsts.fetchONRoles);

    const [deleteMethodState, setDeleteMethodState] = useState<{
        delete_ids: number[];
        deactivate_ids: number[];
        activate_ids: number[];
    }>({
        delete_ids: [],
        deactivate_ids: [],
        activate_ids: [],
    });

    const accountStatusList = [
        { id: "trial", name: "Trial" },
        { id: "paid", name: "Paid" },
    ];

    const mmPlanList = [
        { id: "active", name: "Active" },
        { id: "inactive", name: "Inactive" },
    ];

    const [searchquery, setSearchquery] = useState<string>("");
    const dispatch = useDispatch<appDispatch>();
    const navigate = useNavigate();

    const handleStatusChange = (values: any[]) => {
        setSelectedStatus(values);
    }

    const openFilterModal = () => {
        setBackupFilters({
            membershipPlans,
            selectedStatus,
            selectedMMPlan,
            selectedRole,
            selectedSpecialty,
        });
        setPopoverVisible(true);
    };

    const handleCancelFilters = () => {
        setMembershipPlans(backupFilters.membershipPlans);
        setSelectedStatus(backupFilters.selectedStatus);
        setSelectedMMPlan(backupFilters.selectedMMPlan);
        setSelectedRole(backupFilters.selectedRole);
        setSelectedSpecialty(backupFilters.selectedSpecialty);
        setPopoverVisible(false);
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        dispatch(fetchSitesList(arr));
        dispatch(fetchSpecialityList(params));
        dispatch(fetchRolesList());

        return () => {
            dispatch(resetFetchSitesList());
            dispatch(resetFetchSpecialityList());
            dispatch(resetFetchRolesList());
        };
    }, []);
    console.log(selectedStatus, "selectedStatus")
    const handleFilter = (obj:any) => {
console.log(obj,"objjj")
        let payload: any = {
            practice_site_ids: [],
            subscription_plan_ids: membershipPlans,
            role_ids: selectedRole,
            specialty_ids: selectedSpecialty,
        };

        // For active/inactive
        if (activeTab === "active" || activeTab === "inactive") {
            //   payload.is_active_member = activeTab === "active" ? true : false;
            payload.user_type = activeTab === "active" ? "MEMBER" : "NON_MEMBER"
            payload.has_active_membership_plan = selectedMMPlan?.includes("inactive") ? false : true
            payload.is_trial_account = obj ==="trial" ? true : false
            payload.approval_status = activeTab === "active" ? "APPROVED" : "REJECTED"

        }

        // For deleted
        if (activeTab === "deleted") {
            payload.is_account_deleted = true;

        }
        dispatch(filterMembers(payload))
            .unwrap()
            .then((result) => {

                if (onFilterResults) {
                    onFilterResults(result?.result?.data);
                }
            })
            .catch((error) => {
                console.error("Error fetching filtered results:", error);
            });
    };

    const handleMembershipPlansChange = (values: string[]) => {
        setMembershipPlans(values);

    };

    const handleActiveChange = (e: RadioChangeEvent) => {
        setActive(e.target.value);
        onActiveChange(e.target.value);
        setUseSelectedRows([]);
    };



    const TextWithCheckbox = (props: any) => {
        return (
            <div>
                <Checkbox
                    checked={props.checked}
                    style={{ margin: "0 .5rem 0 0rem" }}
                />
                {props.children}
            </div>
        );
    };


    //handle to resend email to selected users(row)
    const handleResendEmail = () => {
        const userIdsToResendEmail = selectedRows.map((item: any) => item.id);
        const selectedUsersName = selectedRows.map((item: any) => item.username).join(', ');

        const payload = {
            selected_ids: userIdsToResendEmail,
        };
        confirm({
            title: "Re-Send Email confirmation",
            icon: <ExclamationCircleOutlined />,
            centered: true,
            content: (<p>Are you sure you want to Re-send Email to the  <b>{selectedUsersName}</b> ?</p>),
            onOk() {
                dispatch(resendEmail(payload)).then(handleApiResponse);
                resetTableSelection()
            },
            onCancel() { },
        });

    };
    const items: MenuProps["items"] = [
        {
            label: "--- Select ---",
            key: 0,
        },
        {
            label:
                selectedRows && selectedRows[0]?.is_active
                    ? "Deactivate Selected User"
                    : "Activate Selected User",
            disabled:
                (selectedRows && selectedRows.length === 0) ||
                selectedRows === undefined,
            key: "2",
            icon: <DeleteOutlined />,
            onClick: () => {
                const isUserActive = selectedRows[0]?.is_active;
                confirm({
                    title: isUserActive
                        ? "Deactivate confirmation"
                        : "Activate confirmation",
                    icon: <ExclamationCircleOutlined />,
                    centered: true,
                    content: isUserActive
                        ? "Are you sure you want to deactivate?"
                        : "Are you sure you want to activate?",
                    onOk() {
                        const userIdsToChangeStatus = selectedRows.map(
                            (item: any) => item.id
                        );

                        if (isUserActive) {
                            // Deactivate the selected user
                            const updatedDeleteMethod = {
                                ...deleteMethodState,
                                deactivate_ids: [
                                    ...deleteMethodState.deactivate_ids,
                                    ...userIdsToChangeStatus,
                                ],
                            };
                            dispatch(multiFunctionDeleteUsers(updatedDeleteMethod))
                                .then((data) => {
                                    if (data.payload.isSuccess) {
                                        resetTableSelection()
                                        toast.success(data.payload.message);
                                    } else {
                                        toast.error(data.payload);
                                    }
                                })
                                .then((data) => dispatch(fetchUsersList({ searchquery, pageNumber })));

                        } else {
                            // Activate the selected user
                            const updatedActivateMethod = {
                                ...deleteMethodState,
                                activate_ids: [
                                    ...deleteMethodState.activate_ids,
                                    ...userIdsToChangeStatus,
                                ],
                            };
                            dispatch(multiFunctionDeleteUsers(updatedActivateMethod))
                                .then((data) => {
                                    if (data.payload.isSuccess) {
                                        resetTableSelection()
                                        toast.success(data.payload.message);
                                    } else {
                                        toast.error(data.payload);
                                    }
                                })
                                .then((data) =>
                                    dispatch(fetchUsersList({ searchquery, pageNumber }))
                                );
                        }
                    },
                    onCancel() { },
                });
            },
        },

        {
            label: "Resend Email",
            disabled:
                (selectedRows && selectedRows.length === 0) ||
                selectedRows === undefined,
            key: "1",
            icon: <MailOutlined />,
            onClick: () => {
                handleResendEmail();
            },
        },
    ];


    const handleRoleChange = (value: any) => {
        setSelectedRole(value);
        dispatch(fetchONSpecialities({ roleIDs: value.join(",") }))

    };

    const tagRender = (props: any) => {
        const { label, value, closable, onClose } = props;
        const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
            event.preventDefault();
            event.stopPropagation();
        };

        return (
            <Tag
                onMouseDown={onPreventMouseDown}
                closable={closable}
                onClose={onClose}
                style={{
                    marginRight: 3, padding: ".25rem",
                }}
            >
                {label?.props?.children ? label?.props?.children : null}
            </Tag>
        );
    };



    const clearFilters = () => {
        console.log(selectedStatus,"valuee")
        // setSelectedRole([]);
        // setSelectedSpecialty([]);
        setMembershipPlans([])
        // setSelectedStatus([{ id: "trial", name: "Trial" }]);
        onClearAll();
        setPopoverVisible(false);
        handleFilter("trial");
    };
    const arr = {
        searchQuery: "",
        isSearchApi: false,
    };

    const params = {
        searchQuery: "",
        activeStatus: 'true',
        role: ""
    };

    return (
        <div className="user-table-container">
            <Row justify="end" style={{ marginBottom: "1rem" }}>
                <Col>
                    <Button
                        icon={<MdOutlineSubject />}
                        className="filter-button"
                        onClick={() => {
                            openFilterModal()
                            if (setUseSelectedRows) {
                                setUseSelectedRows([]);
                            }
                        }}
                    >
                        {isMobile ? "" : "Filter"}
                    </Button>
                </Col>
            </Row>
            <Modal
                width={300}
                centered={true}
                closeIcon={false}
                open={isPopoverVisible}
                footer={[
                    <Button key="cancel" onClick={handleCancelFilters}>
                        Cancel
                    </Button>,
                    <Button
                        key="apply"
                        type="primary"
                        style={{ margin: "0 0.5rem 1rem 1rem" }}
                        onClick={() => {
                            setPopoverVisible(false)
                            handleFilter(selectedStatus)
                        }}
                    >
                        OK
                    </Button>,
                ]}
            >
                <div className="popover-content" style={{ padding: "5px" }}>
                    <div className="popover-header">
                        <h4>Filter</h4>
                        <Button onClick={clearFilters} className="clear-all-button">
                            Clear All
                        </Button>
                    </div>

                    {activeTab === "active" ?
                        <div className="popover-item">
                            <label className="label-text" style={{ marginBottom: "0.75rem", display: "block" }}>
                                By Account Status
                            </label>
                            <Radio.Group
                                onChange={(e) => handleStatusChange(e.target.value)}
                                value={selectedStatus}
                                style={{ display: "flex", flexDirection: "row", gap: "1rem" }}
                            >
                                {accountStatusList?.map((item: any) => (
                                    <Radio key={item.id} value={item.id}>
                                        {item.name}
                                    </Radio>
                                ))}
                            </Radio.Group>
                        </div> : null}
                    {/* {activeTab === "deleted" ?

                        <div className="popover-item">
                            <label className="label-text" style={{ marginBottom: "0.75rem", display: "block" }}>
                                By MM Plan Activity
                            </label>
                            <Radio.Group
                                onChange={(e) => handleMMPlanChange(e.target.value)}
                                value={selectedMMPlan}
                                style={{ display: "flex", flexDirection: "row", gap: "1rem" }}
                            >
                                {mmPlanList?.map((item: any) => (
                                    <Radio key={item.id} value={item.id}>
                                        {item.name}
                                    </Radio>
                                ))}
                            </Radio.Group>
                        </div>
                        : null} */}
                    {/* <div className="popover-item">
            <label className="label-text">By Role</label>
              <Select
              mode="multiple"
              style={{
                width: "100%",
                height:"3rem"
              }}
              className='role-select'
              onChange={handleRoleChange}
              placeholder={"Select Roles"}
              maxTagCount={"responsive"}
              value={selectedRole}
              virtual={false}
              tagRender={tagRender}
              dropdownRender={(menu) => (
                <>
                  <Space style={{ padding: "5px 12px 4px" }}>
                 <Checkbox
  checked={
    selectedRole.length > 0 &&
    selectedRole.length === ONRolesListData?.length
  }
  onChange={(e) =>
    handleSelectAll(e, handleRoleChange, ONRolesListData, "role")
  }
>
  Select All
</Checkbox>
                  </Space>
                  <Divider style={{ margin: "8px 0" }} />
                  {menu}
                </>
              )}
            >
             {ONRolesListData?.map((item: any) => (
  <Option key={item.id} value={item.id}>
    <TextWithCheckbox checked={selectedRole?.includes(item?.id)}>
      {item?.name}
    </TextWithCheckbox>
  </Option>
))}
            </Select>
          </div> */}

                    {/* <div className="popover-item">
            <label className="label-text">By Speciality</label>
           <Select
                        mode="multiple"
                        disabled={ONSpecialitiesListData?.length===0}
                        style={{
                          width: "100%",
                          height: "3rem",
                        }}
                        className='specialty-select'
                        onChange={handleSpecialtyChange}
                        placeholder={"Select Specialty"}
                        maxTagCount={"responsive"}
                        value={selectedSpecialty}
                        virtual={false}
                        tagRender={tagRender}
                        dropdownRender={(menu) => (
                          <>
                            <Space style={{ padding: "5px 12px 4px" }}>
                              <Checkbox
  checked={
    selectedSpecialty.length > 0 &&
    selectedSpecialty.length === ONSpecialitiesListData?.length
  }
  onChange={(e) =>
    handleSelectAll(e, handleSpecialtyChange, ONSpecialitiesListData, "specialty")
  }
>
  Select All
</Checkbox>
                            </Space>
                            <Divider style={{ margin: "8px 0" }} />
                            {menu}
                          </>
                        )}
                      >
                       {ONSpecialitiesListData?.map((item: any) => (
  <Option key={item.id} value={item.id}>
    <TextWithCheckbox checked={selectedSpecialty?.includes(item?.id)}>
      {item?.name}
    </TextWithCheckbox>
  </Option>
))}
                      </Select>
          </div> */}
                    {/* <div className="popover-item">
            <label className="label-text">By Speciality</label>
            <Select
              value={speciality}
              onChange={handleSpecialityChange}
              style={{ width: "100%", marginTop: ".5rem" }}
              virtual={false}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option: any) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              <Select.Option value="">All</Select.Option>
              {SpecialityListData?.map((option: any) => (
                <Select.Option key={option?.id} value={option?.id}>
                  {option?.name}
                </Select.Option>
              ))}
            </Select>
          </div> */}
                    <div className="popover-item">
                        {/* <label className="label-text">By Alphabet(First name)</label>
            <Select
              value={selectedAlphabet}
              onChange={handleAlphabetChange}
              style={{ width: "100%", marginTop: ".5rem" }}
              virtual={false}
            >
              {alphabetOptions?.map((option) => (
                <Option key={option} value={option}>
                  {option}
                </Option>
              ))}
            </Select> */}


                        <div className="popover-item">
                            <label className="label-text"> By Membership Plan</label>
                            <Select
                                placeholder="Select Plan"
                                mode="multiple"
                                value={membershipPlans}
                                onChange={handleMembershipPlansChange}
                                style={{ width: "100%", marginTop: ".5rem" }}
                                virtual={false}
                                showSearch
                                optionFilterProp="children"
                                optionLabelProp="label"
                                maxTagCount="responsive"
                                dropdownStyle={{ maxHeight: 200, overflow: "auto" }}
                            >
                                {planOptions.map((option) => (
                                    <Select.Option key={option.value} value={option.value} label={option.label}>
                                        <Checkbox checked={membershipPlans.includes(option.value)}>
                                            {option.label}
                                        </Checkbox>
                                    </Select.Option>
                                ))}
                            </Select>
                        </div>

                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default ActiveListAction;
